<template>
    <div class="tv-body" id="tv-body" ref="tvBody">
        
        <loading @load="init"></loading>
        <div class="tv-body-inset" v-if="isAlive" id="tv-body-inset">
            <tv-marquee :lists="marqueeList"></tv-marquee>
            <home id="home" ref="home" :logo="images.logoWhite" :image="images.page1Image0"></home>
            <introduction id="introduction" ref="introduction"></introduction>
            <channel-list id="channelList" ref="channelList"></channel-list>
            <multi-device id="multiDevice" ref="multiDevice"></multi-device>
            <life-style id="lifeStyle" ref="lifeStyle"></life-style>
            <life-proposal id="lifeProposal" ref="lifeProposal"></life-proposal>
            <big-screen id="bigScreen" ref="bigScreen"></big-screen>
            <feedback id="feedback" ref="feedback"></feedback>
            <experience-application id="experienceApplication" ref="experienceApplication"></experience-application>
            <packages-list id="packagesList" ref="packagesList"></packages-list>
            <payment-methods id="paymentMethods" ref="paymentMethods"></payment-methods>
            <tv-footer id="tvFooter" ref="tvFooter"></tv-footer>
            <a-back-top :visibilityHeight="100" :target="backTopBody">
                <div class="ant-back-top-inner">
                    <img :src="images.backTop" />
                </div>
            </a-back-top>
        </div>
        
        <div class="tv-nav">
            <div class="logo">
                <img :src="images.logo" />
            </div>
            <div class="menu-btn-area">
                <menu-to-close :disable="!isAlive" v-model:status.sync="menuShow"></menu-to-close>
            </div>
            <transition name="menu">
            <div class="menu-list" v-show="menuShow">
                <a-anchor 
                    :affix="true"
                    :target-offset="60"
                    @click="linkTo">
                    <a-anchor-link 
                        class="menu" 
                        v-for="(n, index) in menuList"
                        :key="index"
                        :title="n.name"
                        :href="`#${n.to}`"
                        >
                    </a-anchor-link>
                </a-anchor>
            </div>
            </transition>
        </div>
        
    </div>
</template>
<script>
import loading from '../../components/loading'
import images from '../../images'
import menuToClose from '../../components/menu-to-close'
import tvMarquee from '../../components/tv-marquee'
import home from './modules/home'
import introduction from './modules/introduction'
import channelList from './modules/channel-list'
import multiDevice from './modules/multi-device'
import lifeStyle from './modules/life-style'
import lifeProposal from './modules/life-proposal'
import bigScreen from './modules/big-screen'
import feedback from './modules/feedback'
import experienceApplication from './modules/experience-application'
import packagesList from './modules/packages-list'
import paymentMethods from './modules/payment-methods'
import tvFooter from './modules/footer'
export default {
    components: {
        loading,
        menuToClose,
        tvMarquee,
        home,
        introduction,
        channelList,
        multiDevice,
        lifeStyle,
        lifeProposal,
        bigScreen,
        feedback,
        experienceApplication,
        packagesList,
        paymentMethods,
        tvFooter
    },
    mounted () {
        window.qrcodeShow = this.qrcodeShow
    },
    data () {
        return {
            isAlive: false,
            images,
            menuShow: false,
            marqueeList: ['海外で日本のテレビを観るアプリ！iPhone、iPad、Androidのスマホや、firiTVStick、Googleplay対応のSmartTV 、BOXなどマルチデバイスに対応します。'],
            menuList: [{
                name: '一週間無料体験',
                to: 'home'
            },{
                name: 'KaitekiTVの特徴',
                to: 'introduction'
            },{
                name: '視聴可能チャンネル一覧',
                to: 'channelList'
            },{
                name: 'アプリ対応端末',
                to: 'multiDevice'
            },{
                name: 'KaitekiTVライフスタイル',
                to: 'lifeStyle'
            },{
                name: 'お客様の声',
                to: 'feedback'
            },{
                name: '料金体系',
                to: 'packagesList'
            }],
            backTopBody: () => {
                return window
            }
        }
    },
    watch: {
        isAlive (n) {
            console.log(n)
            if (n) {
                this.backTopBody = () => {
                    return document.getElementById('tv-body-inset')
                }
            }
        }
    },
    methods: {
        init () {
            this.isAlive = true
        },
        linkTo (e,link) {
            e.preventDefault()
            console.log(link)
            this.menuShow = false
            // this.$refs
        },
        qrcodeShow (imageUrl) {
            this.$refs.qrcodeShow.init(imageUrl)
        },
        getContainer (index) {
            return this.$refs[this.menuList[index].to][0]
        },
        routerTo (path) {
            this.$route.push(path)
        }
    }
}
</script>
<style scoped>
.tv-body {
    width: 100%;
    height: 100%;
    margin: 0;
}
.tv-nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: #fff;
    box-sizing: border-box;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    z-index: 0;
    border-bottom: solid 2px  #D1D1D1;;
}
.logo img {
    display: block;
    height: 100%;
}
.menu-btn-area {
    padding-top: 10px;
}
.menu-list {
    position: absolute;
    width: 100%;
    background: #fff;
    top: 60px;
    left: 0;
    height: auto;
    min-height: 40px;
    box-sizing: border-box;
    padding: 15px;
    transition: all .5s;
    overflow: hidden;
}
.menu-list .menu:nth-last-child(1) {
    border:none
}
.menu {
    width: 100%;
    border-bottom: solid 1px #EEEEEE;
    height: 40px;
    padding: 5px;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 30px;
    font-weight: normal;
}
.menu-leave-to, .menu-enter/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.menu-enter-to, .menu-leave {
  opacity: 1;
}
.tv-body-inset {
    width: 100%;
    box-sizing: border-box;
    padding-top:60px;
    height: 100%;
    overflow-x:hidden ;
    overflow-y:auto;
}
* >>> .ant-anchor-ink{
    display: none;
}
* >>> .ant-anchor-link-title{
    height: 100%;
}
* >>> .ant-anchor-link-active > .ant-anchor-link-title{
    color:#fdb819
}
.ant-back-top {
  bottom: 50px;
}
.ant-back-top-inner img{
    display: block;
    width: 45px;
    height: 45px;
}
</style>